import { dictionaryModalTitle, postCreateDictionary } from '..'
import { DictionaryForm, DictionaryFormRef } from '../../DictionaryForm'
import { notification } from 'antd'
import { ModalEmpty } from 'components/atoms/modal'
import { useCallback, useEffect, useRef, useState } from 'react'

export type DictionaryModalCreateProps = {
  dictionary_type: string
  onClose?: () => void
  onCreated?: (value: any) => void
}

export const DictionaryModalCreate = (props: DictionaryModalCreateProps) => {
  const { dictionary_type, onClose, onCreated } = props
  const form = useRef<DictionaryFormRef>(null)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(Boolean(dictionary_type))

  const handleFinish = useCallback(
    async (values: any) => {
      setLoading(true)
      const { data, errors } = await postCreateDictionary(values)

      console.log('** RYAN DictionaryModalCreate.tsx 24 values : ', values)
      if (errors.length) {
        const fieldData: any[] = []
        errors.forEach((error) => {
          if (
            typeof error.name === 'string' &&
            ['name', 'field'].includes(error.name)
          ) {
            fieldData.push({
              name: error.name,
              errors: error.errors,
              touched: true
            })
          }
        })
        if (fieldData.length) {
          setTimeout(() => {
            form.current?.setFields(fieldData)
            form.current?.scrollToField(fieldData?.[0]?.name, {
              behavior: 'smooth',
              block: 'center'
            })
          }, 0)
        } else {
          notification.error({
            message: errors.flatMap((error) => error.errors)
          })
        }
        setLoading(false)
        return
      }

      notification.success({
        message: `${dictionaryModalTitle[dictionary_type]} field is saved successfully`
      })
      setLoading(false)
      onCreated?.(data)
    },
    [onCreated, form.current]
  )

  const handleCancel = () => {
    setOpen(false)
    onClose?.()
  }

  useEffect(() => {
    setOpen(Boolean(dictionary_type))
  }, [dictionary_type])

  useEffect(() => {
    return () => {
      setLoading(false)
      form.current?.resetFields()
    }
  }, [])

  return (
    <ModalEmpty
      open={open}
      keyboard={false}
      title={`New Data Field ${dictionaryModalTitle[dictionary_type]}`}
      onCancel={handleCancel}
      cancelButtonProps={{ disabled: loading }}
      okText="Continue"
      okButtonProps={{ loading }}
      onOk={() => form.current?.submit()}
      destroyOnClose>
      <DictionaryForm
        ref={form}
        type={dictionary_type}
        loading={loading}
        onFinish={handleFinish}
      />
    </ModalEmpty>
  )
}
